import UserProfile from './UserProfile/UserProfile';
import styles from './Settings.module.css';

function Settings() {
    return (
        <div className={styles.settingsPage}>
            <UserProfile />
        </div>
    )
}

export default Settings;